import tpl from './maintenance-stripe.tpl.html';
import './maintenance-stripe.component.scss';
import commonFiltersMod from '../filters';

/**
 * Maintenance stripe is a stripe shown on every page reminding the user that the site is in maintenance mode and that
 * not all features may work on the site.
 */
class MaintenanceStripeComponent {
  constructor() {
    'ngInject';

    /**
     * End time of the maintenance, if available.
     * @type {?Moment}
     */
    this.endTime = null;
  }
}

const config = {
  templateUrl: tpl,
  controller: MaintenanceStripeComponent,
  bindings: {
    endTime: '<?'
  }
};

const mod = angular.module('app.common.keepalive.maintenanceStripeComponent', [
  commonFiltersMod,
])
.component('maintenanceStripe', config);

export default mod.name;
